import { MediaType } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/types';
import React from 'react';
export const getMediaAlternativesRadioOptions = t => [{
  id: MediaType.AUDIO,
  label: t('accessibility-wizard.rules-list.media-alternatives.radio.options.audio-only'),
  option: MediaType.AUDIO,
  requirements: /*#__PURE__*/React.createElement("ul", {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement("li", null, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.audio-only.requirements.li.1`))),
  secondaryLabel: t('accessibility-wizard.rules-list.media-alternatives.radio.options.audio-only.secondary')
}, {
  id: MediaType.VIDEO,
  label: t('accessibility-wizard.rules-list.media-alternatives.radio.options.video-only'),
  option: MediaType.VIDEO,
  requirements: /*#__PURE__*/React.createElement("ul", {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement("li", {
    style: {
      marginBottom: '9px'
    }
  }, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.video-only.requirements.li.1`)), /*#__PURE__*/React.createElement("li", null, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.video-only.requirements.li.2`))),
  secondaryLabel: t('accessibility-wizard.rules-list.media-alternatives.radio.options.video-only.secondary')
}, {
  id: MediaType.VIDEO_WITH_AUDIO,
  label: t('accessibility-wizard.rules-list.media-alternatives.radio.options.video-with-audio'),
  option: MediaType.VIDEO_WITH_AUDIO,
  requirements: /*#__PURE__*/React.createElement(React.Fragment, null, t('accessibility-wizard.rules-list.media-alternatives.radio.options.video-with-audio.requirements'), /*#__PURE__*/React.createElement("ul", {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement("li", {
    style: {
      marginBottom: '9px',
      marginTop: '9px'
    }
  }, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.video-with-audio.requirements.li.1`)), /*#__PURE__*/React.createElement("li", null, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.video-with-audio.requirements.li.2`)))),
  secondaryLabel: t('accessibility-wizard.rules-list.media-alternatives.radio.options.video-with-audio.secondary')
}, {
  id: MediaType.DECORATIVE,
  label: t('accessibility-wizard.rules-list.media-alternatives.radio.options.decorative-video-or-audio'),
  option: MediaType.DECORATIVE,
  requirements: /*#__PURE__*/React.createElement("ul", {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement("li", null, t(`accessibility-wizard.rules-list.media-alternatives.radio.options.decorative-video-or-audio.requirements.li.1`)))
}];
//# sourceMappingURL=media-alternatives-radio-options.js.map